module.exports = __webpack_public_path__ + "static/media/keyboard.514fe14e.svg";